<template>
    <footer class="creditFooter" v-if="show">
        <img :src="require('@/assets/gomXchange.png')" alt="gomXchange logo" class="creditLogo">
        <div class="creditLinks"> 
            <a href="https://www.40geo.com">
                <img alt="" src="https://images.squarespace-cdn.com/content/5f9afb2bb37e57471b3a025f/1605409991995-Z4E91O5XKN6CV3MYJAKS/40Geo_logo3.png?format=1500w&content-type=image%2Fpng" width="70/" />
            </a>
            <a href="https://www.spire.com">
                <img alt="" src="https://spire.com/wp-content/themes/spire/img/spire_logo_red_white.svg" width="70" />
            </a>
            <a href="https://www.setld.com">
                <img alt="" :src="require('@/assets/setld_logo_v1.2.png')" width="80" />
            </a>
        </div>
    </footer>
</template>

<script>
export default {
    props: [
        "enableNoBorder"
    ],
    data: () => ({
        show: true
    }),
    methods: {
        checkNoBorder: function() {
            var globv = this;
            if (globv.enableNoBorder && ![null, undefined].includes(globv.$route.query.noborder)) {
                globv.show = !globv.$route.query.noborder;
            }
            else {
                globv.show = true;
            }
        }
    },
    mounted: function() {
        var globv = this;
        globv.checkNoBorder();
    },
    watch: {
        '$route.query.noborder': function() {
            var globv = this;
            globv.checkNoBorder();
        }
    }
}
</script>

<style lang="scss" scoped>
.creditFooter {
    display: flex;
    justify-content: space-between;
    width: 100%;
    background-color:#9e9e9e;
    background-color: var(--footerBackgroundColor);
    padding: 10px 5px;
}

.creditLinks {
  display: flex;
  align-items: center;

  a {
    padding: 5px 10px;
  }
}

.creditLogo {
    height: 3rem;
}

@media (max-width: 560px) {
    .creditFooter {
        flex-direction: column;
        align-items: center;
    }
}

@media (max-width: 290px) {
    .creditFooter .creditLinks {
        flex-direction: column;
    }
}
</style>